import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AdminEmptyState = ({ icon, title, description, action }) => (
  <section className="admin-empty-state">
    {icon ? (
      <div className="admin-empty-state-icon">
        <FontAwesomeIcon icon={icon} size="lg" />
      </div>
    ) : null}
    <h3 className="admin-empty-state-title">{title}</h3>
    {description ? <p className="admin-empty-state-description">{description}</p> : null}
    {action ? <div className="admin-empty-state-action">{action}</div> : null}
  </section>
);

export default AdminEmptyState;
